import store from '../state/store'
import axios from 'axios'

store.on('scheduled_calls:index', function() {
  store.get().ui.scheduled_calls.set({loading: true})

  axios.get("/api/sales/scheduled_calls")
  .then(function(response) { 
    store.get().set({scheduled_calls: response.data.scheduled_calls})
    store.get().ui.scheduled_calls.set({subscribed: response.data.subscribed})
  })
  .catch(function(error) {
    handleError(error)
  })
  .then(function() {
    store.get().ui.scheduled_calls.set({loading: false})
  })
})

store.on('scheduled_calls:subscribe', function(value) {
  axios.post("/api/sales/scheduled_calls/subscribe", {subscribe_scheduled_calls: value})
  .then(function(response) { 
    store.get().ui.scheduled_calls.set({subscribed: response.data.subscribed})
  })
  .catch(function(error) {
    handleError(error)
  })
})

